export function displayErrorMessage($container, isShortMessage = false){
	const msg = isShortMessage ? apiErrorMessage.short : apiErrorMessage.long;
	$container.html(`<p class="api-error">${msg}</p>`);
}

export const apiErrorMessage = {
	long: 'Oops! Something went wrong and we could not retrieve the details. Please try again later. <br />If the problem persists, please raise this directly with your brigade, group or unit leader to escalate with your DFES Regional Office.',
	short: 'Cannot retrieve details'
}